/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";

export const muiFormLabelStyle = (): Components<Theme>["MuiFormLabel"] => ({
  styleOverrides: {
    root: {
      lineHeight: "inherit",
    },
  },
  defaultProps: {
    required: false,
  },
});
